import { ITaskRow } from 'types/operationsTasks.interface'

export const MOCK_TASKS: ITaskRow[] = [
  {
    id: 1,
    taskTemplate: 'Equipment inspection',
    department: 'Maintenance',
    location: 'Pit B',
    priority: 'High',
    assignment: 'Auto-assign',
    assignees: null,
    startAt: '20. 05. 2026., 08:00',
    evidenceRequired: true,
  },
  {
    id: 2,
    taskTemplate: 'Safety walkdown',
    department: 'Operations',
    location: 'Crusher Area',
    priority: 'Critical',
    assignment: 'Pick Worker(s)',
    assignees: 'Peter M., Anna V.',
    startAt: '20. 05. 2026., 09:30',
    evidenceRequired: true,
  },
  {
    id: 3,
    taskTemplate: 'Pre-start checklist',
    department: 'Maintenance',
    location: null,
    priority: 'Normal',
    assignment: 'Auto-assign',
    assignees: null,
    startAt: '20. 05. 2026., 10:15',
    evidenceRequired: false,
  },
  {
    id: 4,
    taskTemplate: 'Haul route verification',
    department: 'Haulage',
    location: 'Haul Road',
    priority: 'Low',
    assignment: 'Pick Worker(s)',
    assignees: 'Michael K.',
    startAt: '20. 05. 2026., 14:00',
    evidenceRequired: false,
  },
  {
    id: 5,
    taskTemplate: 'Safety walkdown',
    department: 'Camp Services',
    location: 'Main Gate',
    priority: 'Normal',
    assignment: 'Auto-assign',
    assignees: null,
    startAt: '21. 05. 2026., 06:00',
    evidenceRequired: false,
  },
]
